import { BonanzaContext } from 'contexts/bonanza';
import {
  BONANZA_ACTIVE_PROGRESS_STATUSES,
  BONANZA_STARTED_STORAGE,
  BonanzaStatus,
  getCurrentBonanzaIterationDays,
} from 'helpers/bonanza';
import 'moment/locale/de';
import 'moment/locale/fr';
import moment from 'moment';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const MIN_BONANZA_DAYS_TO_SHOW_EXTENDED = 7;

export const useBonanzaLogic = () => {
  const { bonanzaData, userBonanzaGroup } = useContext(BonanzaContext);
  const {
    i18n: { language },
  } = useTranslation();

  const isOneWeekRemains = useMemo(() => {
    if (!bonanzaData) return false;
    const now = moment();
    const diffDays = moment(bonanzaData.end).diff(now, 'days');
    return diffDays < MIN_BONANZA_DAYS_TO_SHOW_EXTENDED;
  }, [bonanzaData]);

  const iterationDays = useMemo(() => {
    if (!bonanzaData) return null;
    return getCurrentBonanzaIterationDays(
      bonanzaData.start,
      bonanzaData.end,
      language
    );
  }, [bonanzaData, language]);

  const isBonusIssued = userBonanzaGroup === BonanzaStatus.BONUS_ISSUED;
  const isBonusLocked = userBonanzaGroup === BonanzaStatus.PROMO_LOCKED;
  const isLockedOrIssued = isBonusIssued || isBonusLocked;
  const isZeroProgress =
    userBonanzaGroup === BonanzaStatus.LEVEL0 &&
    !localStorage.getItem(BONANZA_STARTED_STORAGE);
  const isActiveProgress = (
    BONANZA_ACTIVE_PROGRESS_STATUSES as readonly BonanzaStatus[]
  ).includes(userBonanzaGroup);

  return {
    isOneWeekRemains,
    isLockedOrIssued,
    isActiveProgress,
    isZeroProgress,
    isBonusIssued,
    isBonusLocked,
    isLastIteration: iterationDays?.isLastIteration ?? false,
    nextIterationStartDay: iterationDays?.nextStartDay ?? null,
    iterationStartDay: iterationDays?.startDay ?? null,
    iterationEndDay: iterationDays?.endDay ?? null,
    iterationEndDayFull: iterationDays?.endDayFull ?? null,
  };
};
